const storageAvailable = (type) => {
  let storage;
  try {
    storage = window[type];
    const x = "__members-area__";
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return (
      e instanceof DOMException &&
      // everything except Firefox
      (e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        e.name === "QuotaExceededError" ||
        // Firefox
        e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
      // acknowledge QuotaExceededError only if there's something already stored
      storage &&
      storage.length !== 0
    );
  }
};

const setWithExpiry = (key, value, ttl) => {
  const now = new Date();

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value,
    expiry: now.getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
};

const getWithExpiry = (key) => {
  const itemStr = localStorage.getItem(key);

  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }

  const item = JSON.parse(itemStr);
  const now = new Date();

  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
};

export const getTimesheetFromCache = (timesheetRef) => {
  if (!storageAvailable("localStorage")) return;
  const storageKey = `timesheet-${timesheetRef}`;
  // eslint-disable-next-line
  return getWithExpiry(storageKey);
};

export const addTimesheetToCache = (timesheet) => {
  if (!storageAvailable("localStorage")) return;
  const storageKey = `timesheet-${timesheet.timesheetRef}`;
  const expiresAt = 1000 * 60 * 60; // 1 hour
  setWithExpiry(storageKey, timesheet, expiresAt);
};
